import React from 'react';
import { FaFileExcel, FaFileCsv } from 'react-icons/fa6';

const TableHeader = ({
  config,
  searchTerm,
  setSearchTerm,
  filters,
  handleFilterChange,
  itemsPerPage,
  setItemsPerPage,
  setCurrentPage,
  totalRecords,
  getFilterOptions,
  selectedRows,
  onExport,
  onDeleteSelected
}) => {
  return (
    <>
      <div className="card-header py-2.5 px-3">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 w-100">
          <div className="d-flex align-items-center gap-2 text-nowrap flex-shrink-0">
            <h5 className="mb-0 fw-bold f-s-16 text-dark">{config.title}</h5>
            <span className="badge bg-light-primary text-primary f-s-12 fw-semibold px-2 py-1 rounded-pill">
              {totalRecords} records
            </span>
          </div>
          
          <div className="d-flex align-items-center justify-content-end gap-2 flex-wrap ms-auto">
            {/* Search */}
            <div className="position-relative flex-grow-1" style={{ minWidth: '140px', maxWidth: '240px' }}>
              <input
                type="text"
                className="form-control form-control-sm w-100"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                style={{ paddingLeft: '30px', height: '34px', borderRadius: '6px' }}
              />
              <i className="iconoir-search position-absolute text-muted" style={{ left: '9px', top: '50%', transform: 'translateY(-50%)', fontSize: '14px' }}></i>
            </div>

            {/* Export Buttons */}
            <div className="btn-group shadow-sm flex-shrink-0" role="group" aria-label="Export Data">
              <button
                type="button"
                className="btn btn-outline-success btn-sm d-inline-flex align-items-center gap-1.5 px-2.5 text-nowrap"
                onClick={() => onExport && onExport("excel")}
                title="Export to Excel (.xlsx)"
                style={{ height: '34px', fontWeight: 600, borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' }}
              >
                <FaFileExcel className="fs-6" />
                <span>Excel</span>
              </button>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1.5 px-2.5 text-nowrap"
                onClick={() => onExport && onExport("csv")}
                title="Export to CSV (.csv)"
                style={{ height: '34px', fontWeight: 600, borderTopRightRadius: '6px', borderBottomRightRadius: '6px' }}
              >
                <FaFileCsv className="fs-6" />
                <span>CSV</span>
              </button>
            </div>
          </div>
        </div>
        
        {/* Filters */}
        {config.filters && (
          <div className="row mt-3 align-items-center">
            <div className="col-md-12">
              <div className="d-flex gap-3 align-items-center flex-wrap">
                {config.filters.map(filter => (
                  <select
                    key={filter.key}
                    className="form-select"
                    value={filters[filter.key] || 'all'}
                    onChange={(e) => handleFilterChange(filter.key, e.target.value)}
                    style={{ width: filter.width || '150px' }}
                  >
                    <option value="all">All {filter.label}</option>
                    {getFilterOptions(filter.key).map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                ))}
                
                <select
                  className="form-select"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  style={{ width: '80px' }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Selected rows actions */}
      {selectedRows.length > 0 && (
        <div className="card-body border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-secondary f-s-14">{selectedRows.length} item(s) selected</span>
            <div className="d-flex gap-2">
              <button 
                className="btn btn-danger btn-sm"
                onClick={() => onDeleteSelected(selectedRows)}
              >
                <i className="iconoir-trash"></i> Delete Selected
              </button>
              <select
                  className="form-select form-select-sm"
                  style={{ width: "120px" }}
                  onChange={(e) => {
                    if (e.target.value) {
                      onExport(e.target.value);
                      e.target.value = "";
                    }
                  }}
                >
                  <option value="">Export</option>
                  <option value="excel">Excel</option>
                  <option value="csv">CSV</option>
                  <option value="copy">Copy</option>
                </select>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TableHeader;